import { useEffect, useRef, type ReactNode } from 'react';
import { useNav, type Screen } from '../state/NavContext';
import { TopBar } from './TopBar';

const TITLES: Record<Screen, string> = {
  home: 'ClueVine — daily word puzzles',
  play: 'Playing · ClueVine',
  stats: 'Stats · ClueVine',
  history: 'History · ClueVine',
  settings: 'Settings · ClueVine',
  howto: 'How to play · ClueVine',
  admin: 'Site admin · ClueVine',
};

/** The standard chrome: skip link + top bar + a centered main column. */
export function AppShell({ children }: { children: ReactNode }) {
  const { route } = useNav();
  const mainRef = useRef<HTMLElement>(null);
  const firstRender = useRef(true);

  // On every screen change: start at the top, move focus into the new screen
  // (the clicked control is usually gone), and name the tab after it.
  useEffect(() => {
    document.title = TITLES[route.screen];
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    window.scrollTo(0, 0);
    mainRef.current?.focus({ preventScroll: true });
  }, [route.screen]);

  return (
    <div className="cv-app">
      <a className="cv-skip-link" href="#cv-main">
        Skip to content
      </a>
      <TopBar />
      <main id="cv-main" className="cv-main" ref={mainRef} tabIndex={-1}>
        {children}
      </main>
    </div>
  );
}
